export default __webpack_public_path__ + "static/media/banner-3.a6359b61.jpg";